import clsx from "clsx";
import IconWithTooltip from "components/IconWithTooltip";
import Switch from "components/Switch";
import { ReactComponent as InfoIcon } from "icons/info-grey.svg";
import PropTypes from "prop-types";
import React from "react";

const OnOffRow = ({
  text,
  state,
  tooltipText = "",
  disabled = false,
  setState,
}) => {
  const handleChange = () => {
    setState(!state);
  };

  return (
    <div className={clsx("on_off_row", { disabled })}>
      <div className="description">
        <span>{text}</span>
        <IconWithTooltip
          icon={<InfoIcon width={11} height={11} />}
          tooltipText={tooltipText}
        />
      </div>
      <div className="switch_block">
        <span className={clsx({ active: !state, inactive: state })}>Off</span>
        <Switch
          id="on-off-row-switch"
          currentSwitchState={state}
          disabled={disabled}
          handleChange={handleChange}
        />
        <span className={clsx({ active: state, inactive: !state })}>On</span>
      </div>
    </div>
  );
};

OnOffRow.propTypes = {
  text: PropTypes.string.isRequired,
  state: PropTypes.bool.isRequired,
  tooltipText: PropTypes.string,
  disabled: PropTypes.bool,
  setState: PropTypes.func.isRequired,
};

export default OnOffRow;
